// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "article.search-result-item{margin-bottom:1.5rem;display:flex;justify-content:space-between}article.search-result-item .content h1, article.search-result-item .content h2{font-size:1.25rem}article.search-result-item .lazy-picture{margin-left:1rem;width:25%;flex-shrink:0;flex-grow:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
